export default "__VITE_ASSET__CnogB4AW__"